import Box from '@mui/material/Box';
import React, { FC, useEffect, useState } from 'react';
import NumberUtils from '../../../../utils/numberUtils';
import { TwButton, TwButtonType } from '../../../TwButtons/TwButtons';
import AddEditMiles, { MileageType } from './AddEditMiles';
import TwTooltip from '../../../TwTooltip/TwTooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface BreakdownComponentProps {
  mileageType: MileageType;
  mileage: number;
  isDriver: boolean;
  tripId: string;
  tooltipText?: string;
  reloadData?: () => void;
  token?: string;
  editable?: boolean;
}

const BreakdownComponent: FC<BreakdownComponentProps> = ({
  mileageType,
  mileage,
  isDriver,
  tripId,
  tooltipText,
  reloadData,
  token,
  editable
}): JSX.Element => {
  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  return (
    <>
      <Box component="div" className="load-detail__data-container__overview--sub-title">
        {mileageType === MileageType.Empty ? 'Empty' : 'Loaded'} miles
        {tooltipText && mileageType === MileageType.Empty && (
          <TwTooltip title={tooltipText} placement="top">
            <InfoOutlinedIcon sx={{ height: '16px' }} />
          </TwTooltip>
        )}
      </Box>
      <Box component="div" className="load-detail__data-container__overview__rate">
        {isDriver && editable ? (
          mileage !== 0 ? (
            <>
              {NumberUtils.formatNumber(mileage, 2)} mi{' '}
              <TwButton
                label="Edit"
                action={(): void => {
                  setIsEdit(true);
                  setIsAddEditModalOpen(true);
                }}
                type={TwButtonType.text}
                sx={{ padding: '0 0 0 10px !important' }}
              />
            </>
          ) : (
            <TwButton
              label="Add mileage"
              action={(): void => {
                setIsEdit(false);
                setIsAddEditModalOpen(true);
              }}
              type={TwButtonType.text}
              sx={{ padding: '0 !important' }}
            />
          )
        ) : (
          `${NumberUtils.formatNumber(mileage, 2)} mi`
        )}
      </Box>

      <AddEditMiles
        open={isAddEditModalOpen}
        tripId={tripId}
        isEdit={isEdit}
        mileageType={mileageType}
        onClose={(): void => {
          setIsAddEditModalOpen(false);
        }}
        miles={mileage}
        reloadData={reloadData}
        token={token}
      />
    </>
  );
};

export default BreakdownComponent;
